import { Configuration2D } from '../../configuration2d';
import { Location } from '../../location';
import { Resume } from '../../resume/resume';

export class Configuration extends Configuration2D {
  set resume(resume: Resume) {
    throw new Error('Method not implemented.');
  }
  public location: Location = null;

  public projectUUID: string;
  public isLess2Years: boolean;
  public withInstallation: boolean;
  public mensuality: number;
  public duration: number;
  public installationPrice: number;
  public taeg: number;
  public montantTotal: number;

  constructor() {
    super();
  }
}
